
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FgnF5471H1ComponentService {

  url ={
		saveData :'/saveJsonObject?action_code=vedk27',
	}
  durationInSeconds= 5;

  constructor(private httpClient: HttpClient, private http:HttpClient, private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService) { }

	saveData(baseURL : string, jsonData : any, jsonSetting : any, baseGlobalParams: any, checkLockedObj: any, filterParams: any, ssoId :string) {
		const url = `${baseURL}${this.url.saveData}`;
		const options={
		  withCredentials: true
		};
	
		const data:any = {
		"tax_year":filterParams.tax_year,
		"scenario":filterParams.scenario,
		"jcd_key":baseGlobalParams.jcd_key,
		"sso_id":ssoId,
		"filing_key": filterParams.filing_key,
        "process_name" : 'SAVE_5471_H1_DATA',
		"clob_data": JSON.stringify(jsonData),
        "clob_settings": JSON.stringify(jsonSetting),
		"scenarioCode":baseGlobalParams.scenarioCode,
		"is_issue_key_enabled":baseGlobalParams.is_issue_key_enabled,
		"checkLockedbj": checkLockedObj,
		};
	 console.log("data-----", data);
		const formData = new FormData();
		Object.keys(data).forEach((key) => formData.append(key, data[key]));
	
		console.log('formData =', formData);
		console.log('data =', data);
	
	
		console.log('tax_year = ', formData.get("tax_year"));
		console.log('scenario = ', formData.get("scenario"));
		console.log('jcd_key = ', formData.get("jcd_key"));
		console.log('sso_id =', formData.get("sso_id"));
        console.log('filing_key =', formData.get("filing_key"));
        console.log('clob_settings =', formData.get("clob_settings"));
		console.log('clob_data = ', formData.get("clob_data"));

        return this.http.post<any>(url, formData,options);
	  }

  openSnackBar(message: string, panelClass: string = '') {
    this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
  }

}
